<template>
	<div class="header">
		<div class="header_l">
			<img src="https://res.me.news/assets/images/logo_short.png" alt="" />
			<div class="tab_list">
				<div
					v-for="(item, index) in navlist"
					:key="index"
					@click="toPath(item, index)"
					:class="{ active: currentIndex === index }"
				>
					{{ item.name }}
					<span
						class="tab_tag"
						v-if="item.name == '审核管理' && examineTag > 0"
						>{{ examineTag }}</span
					>
				</div>
			</div>
		</div>
		<el-popover placement="top-start" width="50" trigger="hover">
			<div
				style="text-align: center"
				class="pointer user_tab_tag"
				@click="userInfo"
			>
				个人信息
			</div>
			<div
				style="text-align: center"
				class="pointer user_tab_tag"
				@click="logOut"
			>
				退出
			</div>
			<div class="header_r" slot="reference">
				<img src="../../../assets/logo.png" alt="" />
				<span>{{ userName }}</span>
			</div>
		</el-popover>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { tabTag } from "@/api/data";
export default {
	name: "header",
	data() {
		return {
			currentIndex: 0,
			examineTag: 0,
			userName: this.$store.state.user.user.account,
			navlist: [
				{
					name: "首页",
					router: "/index",
					permissions: 100,
				},
				{
					name: "运营数据",
					router: "/webdata/pvuv",
					permissions: 201,
				},
				{
					name: "资讯管理",
					router: "/message/messagelist",
					permissions: 300,
				},
				{
					name: " 活动管理",
					router: "/event/events",
					permissions: 400,
				},
				{
					name: "DataEra",
					router: "/dataera/dataera_btc",
					permissions: 500,
				},
				{
					name: "广告配置",
					router: "/recommend/bannerlist",
					permissions: 600,
				},
				{
					name: "消息管理",
					router: "/information/push",
					permissions: 700,
				},
				{
					name: "用户管理",
					router: "/user/userlist",
					permissions: 800,
				},
				{
					name: "权限管理",
					router: "/limitsauthority/personnel",
					permissions: 900,
				},
				{
					name: "预测市场",
					router: "/prediction",
					permissions: 1100,
				},
				{
					name: "下载提示配置",
					router: "/appVersion",
					permissions: 1200,
				},
			],
		};
	},
	computed: {
		...mapGetters(["user"]),
	},
	created() {
		this.getDataList();

		this.$watch(
			() => this.$route.path,
			() => {
				this.setActiveTabByRoute();
			},
		);
	},
	mounted() {
		console.log("this.$store.state.user.user", this.$store.state.user.user);

		// Temporarily commented out for testing prediction market

		const role_permissions = this.$store.state.user.user.role_permissions; // 假设格式是 "100,200,300"
		if (role_permissions) {
			const permissionArray = role_permissions.split(",").map(Number); // 转换为数字数组
			this.navlist = this.navlist.filter((item) =>
				permissionArray.includes(item.permissions),
			);
		}

		this.setActiveTabByRoute();
	},
	methods: {
		userInfo() {
			this.$router.push({
				path: "/limitsauthority/info",
				query: { id: this.$store.state.user.user.id, type: "edit" },
			});
		},
		toPath(item, index) {
			this.currentIndex = index;
			this.$router.push({ path: item.router });
			this.getDataList();
		},
		logOut() {
			store.dispatch("user/logout");
		},
		getDataList() {
			this.examineTag = 0;
		},
		setActiveTabByRoute() {
			const currentPath = this.$route.path;

			// 匹配一级路由路径（如 '/webdata/overview' 的一级是 '/webdata'）
			const matchedTab = this.navlist.find((item) => {
				const basePath = item.router.split("/").slice(0, 2).join("/");
				return currentPath.startsWith(basePath);
			});

			if (matchedTab) {
				this.currentIndex = this.navlist.indexOf(matchedTab);
			} else {
				this.currentIndex = 0; // 默认选中第一个
			}
		},
	},
};
</script>

<style scoped>
.header {
	width: 100%;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: #f9f9f9;
	position: fixed;
	top: 0;
	z-index: 1000;
}

.header_l,
.tab_list {
	display: flex;
	align-items: center;
}
.active {
	color: blue;
}
.tab_list {
	margin-left: 50px;
}

.header_l img {
	width: 40px;
	/* height: 50px; */
	margin-left: 20px;
}

.tab_list div {
	font-size: 16px;
	margin-left: 40px;
	display: flex;
}

.header_r {
	display: flex;
	align-items: center;
	margin-right: 30px;
	font-size: 18px;
}

.header_r span {
	font-size: 18px;
}

.header_r img {
	width: 40px;
	height: 40px;
	border-radius: 50px;
	margin-right: 15px;
}

.tab_tag {
	background-color: red;
	padding-left: 5px;
	padding-right: 5px;
	/* padding-top: 2px; */
	height: 16px;
	margin-top: -6px;
	margin-left: 4px;
	border-radius: 4px;
	color: white;
	display: flex;
	align-content: center;
}

.user_tab_tag {
	font-size: 16px;
	height: 40px;
	align-items: center;
	align-content: center;
}
</style>
